(function Module() {
	'use strict';

	var moment = require('moment');

	module.exports = {
		isValidEmail: function isValidEmail(email) {
			if (email.match(/^[^@\s]+@[^@\s]+\.[^@\s\.]+$/)) {
				return true;
			}

			return false;
		},

		isValidDate: function isValidDate(date, dateFormat, birthdate) {
			var momentDate = moment(date, dateFormat);

			if (!momentDate.isValid()) {
				return false;
			}

			if (birthdate.dateIsBirthdate) {
				if (momentDate.isBetween(moment().subtract(birthdate.maxAge, 'years'), moment())) {
					return true;
				}

				return false;
			}

			return true;
		}
	};
})();
